import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { hasViewHmoCompanyPermission, hasViewHmoSchemesPermission, hasViewHmoTransactionsPermission } from '../../permission-utils/hmo';
import { canViewReports, checkHOD, checkHOU } from '../../permission-utils/settings';

const HMOMenu = () => {
	const profile = useSelector(state => state.user.profile);
	const [isSupervisor, setIsSuperVisor] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			const isHOD = await checkHOD();
			const isHOU = await checkHOU();

			if (isHOD || isHOU) {
				setIsSuperVisor(true);
			}
		};

		fetchData();
	}, []);

	return (
		<>
			{(isSupervisor || canViewReports(profile, 'hmo-audit')) && (
				<li>
					<Link to="/hmo/overview">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>Overview</span>
					</Link>
				</li>
			)}
			{/* {hasViewHmoTransactionsPermission(profile.permissions) && profile.role?.slug === 'it-admin' && (
				<li>
					<Link to="/hmo/transactions/dashboard">
						<div className="icon-w">
							<div className="os-icon os-icon-bar-chart-stats-up" />
						</div>
						<span>Dashboard</span>
					</Link>
				</li>
			)} */}
			{hasViewHmoTransactionsPermission(profile.permissions) && (
				<li>
					<Link to="/hmo/transactions/pending">
						<div className="icon-w">
							<div className="os-icon os-icon-agenda-1" />
						</div>
						<span>Transactions</span>
					</Link>
				</li>
			)}
			{hasViewHmoTransactionsPermission(profile.permissions) && (
				<li>
					<Link to="/hmo/transactions/pending/opd">
						<div className="icon-w">
							<div className="os-icon os-icon-agenda-1" />
						</div>
						<span>UNREG Transactions</span>
					</Link>
				</li>
			)}
			{hasViewHmoCompanyPermission(profile.permissions) && (
				<li>
					<Link to="/hmo">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>HMO Companies</span>
					</Link>
				</li>
			)}
			{hasViewHmoSchemesPermission(profile.permissions) && (
				<li>
					<Link to="/hmo/schemes">
						<div className="icon-w">
							<div className="os-icon os-icon-layers" />
						</div>
						<span>HMO Schemes</span>
					</Link>
				</li>
			)}
		</>
	);
};

export default HMOMenu;
